import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const SidebarDropdown = ({
  id,
  iconClass,
  label,
  children,
  basePath,
  activeDropdown,
  setActiveDropdown,
  className
}) => {
  const location = useLocation();

  const isPathActive = useMemo(() => {
    if (!basePath) return false;
    return (
      location.pathname === basePath ||
      location.pathname.startsWith(basePath + "/") ||
      location.pathname.startsWith(basePath)
    );
  }, [location.pathname, basePath]);

  const isOpen = activeDropdown === id || (activeDropdown === null && isPathActive);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setActiveDropdown(isOpen ? null : id);
  };

  return (
    <li className={`yx-item yx-drop ${isOpen ? "mm-active" : ""} ${isPathActive ? "is-trail" : ""}`}>
      <Link to="#" onClick={toggleDropdown} className={`yx-link sb-drop-btn ${className || ""}`} aria-expanded={isOpen}>
        <span className="yx-ic">
          <i className={`${iconClass}`} />
        </span>
        <span className="yx-tx">{label}</span>

        <span className={`yx-caret ${isOpen ? "open" : ""}`}>
          <i className="pe-7s-angle-down" />
        </span>
      </Link>

      <ul className={`yx-sub ${isOpen ? "mm-show" : "mm-collapse"}`}>
        {children}
      </ul>
    </li>
  );
};

export default SidebarDropdown;
